import React, { useEffect, useState } from 'react'
import { fetchItems, fetchListItems } from '../../../../hooks/useCrud';
import { Link } from 'react-router-dom';
import LoaderAndError from '../../../../components/LoaderAndError';
import { usePagination } from '../../../../hooks/usePagination';
import { fileUrl } from '../../../../api/config';
import { getRelativeTime } from '../../../../api/callApi';

interface catBlog {
    id?: number;
    titre?: string;
}
interface UiCatBlog {
    id?: number;
    titre?: string;
    slug?: string;
    createdAt?: string;
    updatedAt?: string;
}

interface UiBlog {
    id?: number;
    titre?: string;
    sousTitre?: string;
    description?: string;
    idCategory?: number;
    status?: number;
    icone?: string;
    logoFile?: File;
    tug?: string;
    slug?: string; // string primitif
    createdAt?: string;
    updatedAt?: string;
    category_blog?: catBlog;
}
export default function ActualiteMenu() {
    const [categories, setCategories] = useState<UiCatBlog[]>([]);
    const [listData, setDataList] = useState<UiBlog[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);



    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    //fin declaration

    // declaration de la pagination
    const { paginationRange, isCurrentPage, isFirstPage, isLastPage } = usePagination({
        currentPage,
        totalPages,
    });
    const [activeCategorySlug, setActiveCategorySlug] = useState<string | null>(
        null
    );

    // Charger les catégories
    const fetchListCategorie = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiCatBlog>("/fetch_category_blog_data");
            setCategories(res.data);


        } catch (err: any) {
            setError("Impossible de charger les catégories");
        } finally {
            setLoading(false);
        }
    };

    const loadListData = async () => {

        setLoading(true);
        try {
            const res = await fetchItems<UiBlog>('/fetch_blog_data_actualite', {
                q: search,
                page: currentPage,
                limit,
            });
            setDataList(res.data);
            setTotalPages(res.totalPages);
            setLoading(false);
        } catch (err: any) {
            console.error(err);
            setError("Erreur lors du chargement des articles");
            setDataList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchListCategorie();
    }, []);

    useEffect(() => {
        loadListData();

    }, [currentPage, limit, search]);



    return (
        <div className="row child-cols col-match g-3">
            <div className="col-2">
                <div className="uc-navbar-switcher-nav p-1 rounded bg-gray-25 dark:bg-gray-800">
                    <ul className="uc-tab-left fs-5 text-end" data-uc-tab="connect: #uc-navbar-switcher-actualites; animation: uc-animation-slide-right-small, uc-animation-slide-left-small">
                        <li><a href="#">Toutes</a></li>


                        {
                            categories.length <= 0 ? (
                                <LoaderAndError
                                    loading={loading}
                                    error={error}
                                    onClearError={() => setError(null)}
                                />

                            ) : (
                                categories.map((item, index) => (
                                    <li key={index}><Link to={'/category/' + item.slug}>{item.titre} </Link></li>

                                ))
                            )

                        }
                    </ul>
                </div>
            </div>
            <div className="col-10">
                <div id="uc-navbar-switcher-actualites" className="uc-navbar-switcher uc-switcher">
                    {/* Section des actualités récentes*/}
                    <div className="row child-cols col-match g-2">


                        {
                            loading ? (
                                <LoaderAndError
                                    loading={loading}
                                    error={error}
                                    onClearError={() => setError(null)}
                                />
                            ) : listData.length === 0 ? (
                                <p>Aucun article trouvé pour cette catégorie.</p>
                            ) : (
                                listData.map((article) => (
                                    // <BlogCard key={article.id} article={article} />
                                    <div key={article.id}>


                                        <article className="post type-post panel hstack sm:vstack items-start gap-2 overflow-hidden">
                                            <div className="post-media panel overflow-hidden w-200px sm:w-100 order-1 sm:order-0">
                                                <figure className="featured-image m-0 ratio ratio-3x2 uc-transition-toggle overflow-hidden bg-gray-25 dark:bg-gray-800">
                                                    <img className="media-cover image uc-transition-scale-up uc-transition-opaque"
                                                        src={fileUrl + "/images/" + article.icone}
                                                        data-src={fileUrl + "/images/" + article.icone}
                                                        alt="Tournoi régional" data-uc-img="loading: lazy" />
                                                    <Link to={"/blog/" + article.slug} className="position-cover" data-caption="image"></Link>
                                                </figure>
                                                <div className="post-meta-catgory position-absolute top-0 start-0 m-1 fs-7 px-narrow bg-primary d-none sm:d-block">
                                                    <div className="post-category hstack gap-narrow fw-semibold">
                                                        <Link className="text-none text-white" to="#">{article.category_blog?.titre}</Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="post-header panel vstack justify-between gap-1 w-100">
                                                <h3 className="post-title h6 m-0 text-truncate-2">
                                                    <Link className="text-none" to={"/blog/" + article.slug}>{article.titre}</Link>
                                                </h3>
                                                <div className="post-meta panel hstack gap-2 fs-7 fw-normal text-black dark:text-white text-opacity-60">
                                                    <div>
                                                        <div className="post-date hstack gap-narrow">
                                                            <i className="fas fa-clock" data-uc-tooltip="15 Mars, 2024"></i>
                                                            <span>Publiée: {getRelativeTime(article.createdAt ?? "")}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {article.tug
                                                            ?.split(",")
                                                            .map((mot) => mot.trim())
                                                            .filter((mot) => mot.length > 0)
                                                            .map((mot, index) => (
                                                                <span key={index} className="badge rounded-pill bg-primary me-1 mb-1">
                                                                    {mot}
                                                                </span>
                                                            ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </article>

                                    </div>


                                ))
                            )
                        }


                    </div>
                </div>
            </div>
        </div>
    )
}
